// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {NavLink, useLocation, useNavigate, useSearchParams} from "react-router-dom";

// اضافه کردن svg به صفحه
import {ReactComponent as Icon2} from '../assets/img/icons/support.svg'
import {ReactComponent as Icon3} from '../assets/img/icons/bottomNavigation/2.svg'
import {ReactComponent as Icon4} from '../assets/img/icons/bottomNavigation/4.svg'
import {ReactComponent as Icon5} from '../assets/img/icons/bottomNavigation/5.svg'
import {ReactComponent as Icon6} from '../assets/img/icons/bottomNavigation/6.svg'

import {useTranslation} from "react-i18next";
import {AllInbox, CheckBox} from "@mui/icons-material";


export default function BottomNavigation() {
  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t} = useTranslation()

  // استفاده از useNavigate در react-router-dom برای جابجایی بین صفحات و ارسال اطلاعات به صفحات
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // متغیر و useState های لوکال صفحه
  // const [location, setLocation] = React.useState(window.location.pathname)


  // const location = window.location.pathname;

  // function handlerButtonNavigation(event) {
  //   setLocation(event)
  //   navigate(event);
  // }


  return (
     <>
       <div className="bottomNavigationComponent">
         <nav className="bottomNavigationItems">
           <NavLink
              id="trackingNavBottom"
              to={{pathname: '/tracking', search: location?.search}}>
             <Icon6/>
             {t("bottomNavigation.t1")}
           </NavLink>
           <NavLink
              id="employmentNavBottom"
              to={{pathname: '/employment', search: location?.search}}>
             <CheckBox/>
             {t("drawer.t24")}
           </NavLink>

           <NavLink
              id="singleOrderNavBottom"
              className="centerItem"
              to={{pathname: '/singleOrder', search: location?.search}}>
             <Icon3/>
             {t("bottomNavigation.t3")}
           </NavLink>
           <NavLink
              id="walletNavBottom"
              to={{pathname: '/wallet', search: location?.search}}>
             <Icon4/>
             {t("bottomNavigation.t4")}
           </NavLink>
           {/*<NavLink*/}
           {/*   to={{pathname: '/orderList', search: location?.search}}>*/}
           {/*  <AllInbox/>*/}
           {/*  {t("bottomNavigation.t6")}*/}
           {/*</NavLink>*/}
           <NavLink
              id="supportNavBottom"
              to={{pathname: '/support', search: location?.search}}>
             <Icon2/>
             {t("bottomNavigation.t2")}
           </NavLink>
         </nav>
       </div>
     </>
  )
}
